module.exports = (typeof window !== 'undefined' ? window : global)['svelte/animate']